export const RatingQueryKeys = {
  all: ['package'] as const,
  lists: () => [...RatingQueryKeys.all, 'list'] as const,
  list: (filters: object) => [...RatingQueryKeys.lists(), filters] as const,
  details: () => [...RatingQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...RatingQueryKeys.details(), id] as const,
};
